import { isEarlyCheckout } from './isEarlyCheckout';
import { BookingCompressed } from '@jooxter/api';

export const removeEarlyCheckouts = (
  bookings?: BookingCompressed[]
): BookingCompressed[] => {
  if (!bookings) {
    return [];
  }

  return bookings.filter((booking) => !isEarlyCheckout(booking));
};
